import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { Box, Text, VStack } from "native-base";
import Paper from "../../atoms/Paper";
import IconButton from "../../atoms/IconButton";
import useResponsive from "../../util/useResponsive";
import { getBabyStats } from "../../util/getBabyStats";
import PregnancyDashDatas from "./PregnancyDashDatas";
const PregnancyWeekInfosImage = ({ weekNr, dayNr, isBaby = false, children, setWeekNr, }) => {
    const calculatedToEnd = 280 - dayNr;
    const { isSmallScreen } = useResponsive();
    const [heightText, setHeightText] = useState("-");
    const [weightText, setWeightText] = useState("-");
    useEffect(() => {
        const { height, weight } = getBabyStats(weekNr);
        setHeightText(height);
        setWeightText(weight);
    }, [weekNr]);
    return (_jsx(Paper, Object.assign({ bgColor: "#EDF5F3", p: 4, alignItems: "center", width: isSmallScreen ? "100%" : 330, height: 260 }, { children: _jsxs(VStack, Object.assign({ width: "100%" }, { children: [_jsx(Box, Object.assign({ mb: 4, width: "full" }, { children: _jsxs(Text, Object.assign({ color: "gray.600", textAlign: "center" }, { children: [weekNr, ". h\u00E9t"] })) })), _jsxs(Box, Object.assign({ flexDirection: "row", alignItems: "center", width: "full", justifyContent: "space-between" }, { children: [_jsx(IconButton, { variant: "lightGray", iconName: "chevronLeft", size: "sm", onPress: () => {
                                setWeekNr(weekNr - 1);
                            }, isDisabled: weekNr === 1 }), children, _jsx(IconButton, { variant: "lightGray", iconName: "chevronRight", size: "sm", onPress: () => {
                                if (weekNr < 41) {
                                    setWeekNr(weekNr + 1);
                                }
                            } })] })), _jsx(Box, Object.assign({ my: 4, width: "full", alignItems: "center" }, { children: isBaby ? (_jsx(PregnancyDashDatas, { weight: weightText, height: heightText })) : (_jsxs(Text, Object.assign({ fontSize: "md", textAlign: "center" }, { children: [calculatedToEnd, " nap van h\u00E1tra a sz\u00FCl\u00E9sig"] }))) }))] })) })));
};
export default PregnancyWeekInfosImage;
